/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-icons/font/bootstrap-icons.css"
import "./src/styles/fonts.css"

import "./src/styles/global.css"
import "./src/styles/header/nav.css"
import "./src/styles/header/subMenu.css"
import "./src/styles/header/mobileNav.css"
import "./src/styles/footer/footer.css"
import "./src/styles/common/sectionFeature.css"
import "./src/styles/common/sectionAyuda.css"
import "./src/styles/common/SectionExtraFeatures.css"
import "./src/styles/common/sectionHighlightGray.css"
import "./src/styles/common/sectionPruebaAseguis.css"
import "./src/styles/common/sectionResenas.css"
import "./src/styles/common/sectionTextClic.css"
import "./src/styles/common/sectionTitle.css"
import "./src/styles/common/sectionUnete.css"
import "./src/styles/common/sectionWeHaveMore.css"
import "./src/styles/common/cookieConsent.css"
import "./src/styles/index/sectionPossibilities.css"
import { getSavedPreferences } from "./src/components/common/cookieConsent"

const forceScrollTop = () => {
    if (typeof window === "undefined") {
        return
    }

    const html = document.documentElement
    const body = document.body
    const previousHtmlScrollBehavior = html.style.scrollBehavior
    const previousBodyScrollBehavior = body.style.scrollBehavior

    html.style.scrollBehavior = "auto"
    body.style.scrollBehavior = "auto"
    window.scrollTo(0, 0)

    requestAnimationFrame(() => {
        window.scrollTo(0, 0)
        html.style.scrollBehavior = previousHtmlScrollBehavior
        body.style.scrollBehavior = previousBodyScrollBehavior
    })
}

export const onRouteUpdate = ({ location }) => {
    if (typeof window === "undefined") {
        return
    }

    if (!location.hash) {
        forceScrollTop()
    }

    if (getSavedPreferences()?.analytics && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
            event: "gatsby-route-change",
            page_path: location.pathname
        })
    }
}

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
    if (location.hash) {
        return true
    }

    return false
}
